import { Link } from 'react-router-dom'

/**
 * NotFound page — in-voice per PITCH-V3-FLOW-PASS-RAVANA-ELUBAAS-PRIYA.md.
 *
 * Session 15b: polished to match Yan-Vada voice (short, direct, no ornament).
 * Renders when a sponsor slug has no config yet, or when route matches nothing.
 * Per SG1-D4: working surface (Bawa Earth base, no Glow overlay).
 */
export default function NotFound() {
  return (
    <main className="not-found" data-surface="working">
      <p className="not-found-sinhala" aria-hidden="true">යන්-වාද</p>
      <h1 className="not-found-heading">Nothing here. Yet.</h1>
      <p className="not-found-body">
        That page isn't live. If you were looking for a specific sponsor pitch, it
        may not be published yet.
      </p>
      <Link to="/" className="not-found-link">
        ← Back to the main pitch
      </Link>
    </main>
  )
}
